import { render, staticRenderFns } from "./VehicleImageCarousel.vue?vue&type=template&id=2bcb71b1"
import script from "./VehicleImageCarousel.vue?vue&type=script&lang=ts"
export * from "./VehicleImageCarousel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports